var _rect, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlatformautomationLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 73,
    height: 73,
    rx: 8,
    fill: "url(#paint0_linear_581_464)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.375 51.1655C41.6289 51.4651 40.8578 51.7163 40.0602 51.8998L39.7371 56.1093C39.696 56.6468 39.2466 57.0625 38.7075 57.0625H34.291C33.752 57.0625 33.304 56.6468 33.2629 56.1107L32.9398 51.9013C31.2096 51.5033 29.5925 50.8203 28.1311 49.9053L24.9218 52.6562C24.5121 53.0073 23.9025 52.9838 23.5207 52.6019L20.3981 49.4793C20.0162 49.0975 19.9942 48.4879 20.3438 48.0782L23.0947 44.8689C22.1812 43.4075 21.4982 41.7904 21.0987 40.0602L16.8893 39.7371C16.3532 39.696 15.9375 39.2466 15.9375 38.7075V34.291C15.9375 33.752 16.3532 33.304 16.8893 33.2629L21.0987 32.9398C21.4967 31.2096 22.1797 29.5925 23.0947 28.1311L20.3452 24.9218C19.9942 24.5135 20.0177 23.9025 20.3981 23.5221L23.5207 20.3996C23.9011 20.0192 24.5121 19.9957 24.9218 20.3452L28.1311 23.0962C29.5925 22.1826 31.2096 21.4997 32.9398 21.1002L33.2629 16.8907C33.304 16.3532 33.7534 15.9375 34.2925 15.9375H38.709C39.248 15.9375 39.696 16.3532 39.7371 16.8893L39.7562 17.1345C38.6165 18.8838 37.9688 20.9459 37.9688 23.127C37.9688 24.8925 38.3859 26.5845 39.1482 28.0943C38.3124 27.83 37.4224 27.6875 36.5 27.6875C31.6326 27.6875 27.6875 31.6326 27.6875 36.5C27.6875 41.3674 31.6326 45.3125 36.5 45.3125C38.7604 45.3125 40.8152 44.4547 42.375 43.055V51.1655Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6562 30.3153V53.3909C52.6562 55.4192 51.0127 57.0627 48.9844 57.0627C46.956 57.0627 45.3125 55.4192 45.3125 53.3909V30.3153C42.6981 28.9773 40.9062 26.2645 40.9062 23.1258C40.9062 20.0928 42.5806 17.4549 45.054 16.0743C45.1671 16.0126 45.3125 16.1008 45.3125 16.23V24.7502L48.9844 26.219L52.6562 24.7502V16.23C52.6562 16.1008 52.8017 16.0126 52.9148 16.0758C55.3881 17.4564 57.0625 20.0928 57.0625 23.1273C57.0625 26.2645 55.2706 28.9788 52.6562 30.3153Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_581_464",
    x1: 3.5,
    y1: 3,
    x2: 70,
    y2: 70.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#981A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#124B6A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatformautomationLogo2);
export default __webpack_public_path__ + "static/media/platformautomation-logo-2.d2bb045a798878af93cec28391124ba7.svg";
export { ForwardRef as ReactComponent };